import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CustomerTable } from '../../components/Customer/CustomerTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { useSelector } from 'react-redux';

export const Customers = () => {
  const {
    privileges: { clients: privileges = [] },
  } = useSelector((state) => state.userAuth);
  const navigate = useNavigate();

  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      {privileges.includes('create') && (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            navigate('/dashboard/clientes/crear');
          }}
        >
          <PlusOutlined />
          Nuevo
        </Button>
      )}
      <CustomerTable />
    </Card>
  );
};
